import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import AcceptIcon from '../../../components/Icons/AcceptIcon';
import BriefCaseIcon from '../../../components/Icons/BriefCaseIcon';
import CancelIcon from '../../../components/Icons/CancelIcon';
import LargeCancelIcon from '../../../components/Icons/LargeCancelIcon';
import LargeCheckMarkIcon from '../../../components/Icons/LargeCheckMarkIcon';
import MoreInfoIcon from '../../../components/Icons/MoreInfoIcon';
import { Modal } from '../../../components/Modal/Modal';
import SuccessModal from '../../../components/Modal/SuccessModal';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
// import DummyFilterForm from '../../../components/Table/TableFilterForms/DummyFilterForm';
import ViewCompanyProfile from '../../../components/Table/TableSliderViews/ViewCompanyProfile';
import ViewDirectorsInfo from '../../../components/Table/TableSliderViews/ViewDirectorsInfo';
import useAcceptKyc from '../../../hooks/dashboard/kyc-compliance/useAcceptKyc';
import useRejectKyc from '../../../hooks/dashboard/kyc-compliance/useRejectKyc';

const KycTable = () => {
  const {
    acceptKyc,
    loading: acceptKycLoading,
    showSuccessModal: showAcceptSuccessModal,
    setShowSuccessModal: setShowAcceptSuccessModal,
  } = useAcceptKyc();
  const {
    rejectKyc,
    loading: rejectKycLoading,
    showSuccessModal: showRejectSuccessModal,
    setShowSuccessModal: setShowRejectSuccessModal,
  } = useRejectKyc();

  return (
    <Container>
      <Table
        // border
        tableTitle='KYC COMPLIANCE LIST'
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search Partner Name',
          // rightAttr: [
          //   {
          //     type: 'filter',
          //     comp: <DummyFilterForm />,
          //   },
          // ],
        }}
        tableHeader={{
          'Submission Timestamp': 'submittedAt',
          'Partner Business Name': 'name',
          'No of Directors': 'numberOfDirectors',
          Status: 'kycStatus',
        }}
        tableDataSourceUrl='ba/v1/company/kyc?sort=desc'
        cellsCustomComp={{
          submittedAt: <TableDateTimeFormatter dataKey='submittedAt' />,
          kycStatus: <StatusCell statusKey='kycStatus' hasDot />,
        }}
        moreOptionsComponents={[
          <ViewDetails
            key='View directors info'
            label='View directors info'
            width='257px'
            icon={<MoreInfoIcon />}
            sliderCompFn={(data: any) => <ViewDirectorsInfo data={data} />}
          />,
          <ViewDetails
            key='View business  profile'
            label='View business  profile'
            width='257px'
            icon={<BriefCaseIcon />}
            sliderCompFn={(data: any) => <ViewCompanyProfile data={data} />}
          />,
          <ActionRow
            key='Accept KYC'
            label='Accept KYC'
            width='257px'
            icon={acceptKycLoading ? <LoadingOutlined /> : <AcceptIcon />}
            actionFn={async (data: any) => acceptKyc(data?.id)}
            freshTable
            conditionalRenderFn={(data: any) =>
              data?.kycStatus === 'Accepted' || data?.kycStatus === 'Declined'
            }
          />,
          <ActionRow
            key='Reject KYC'
            label='Reject KYC'
            width='257px'
            icon={rejectKycLoading ? <LoadingOutlined /> : <CancelIcon />}
            actionFn={async (data: any) => rejectKyc(data?.id)}
            freshTable
            color='#D20832'
            conditionalRenderFn={(data: any) =>
              data?.kycStatus === 'Declined' || data?.kycStatus === 'Accepted'
            }
          />,
        ]}
        // mobileCellComp={<UserProfileManagementCell />}
        // showPaginationControl={false}
      />

      <Modal
        showModal={showAcceptSuccessModal}
        setShowModal={setShowAcceptSuccessModal}
      >
        <SuccessModal
          icon={<LargeCheckMarkIcon />}
          title='KYC Accepted'
          description='Their business profile is now active and ready to access all features.'
          btnLabel='Close'
          className='pink'
        />
      </Modal>

      <Modal
        showModal={showRejectSuccessModal}
        setShowModal={setShowRejectSuccessModal}
      >
        <SuccessModal
          icon={<LargeCancelIcon />}
          title='KYC Declined'
          description='Their business profile remains inactive until the issues are resolved.'
          btnLabel='Close'
          className='pink'
        />
      </Modal>
    </Container>
  );
};

export default KycTable;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
